import Repository from "../Repository";
import { apiConfig, company } from "../../_helpers/apiHelper";

const resource = "/nodecompare";

export default {
  get() {
    return Repository.get(`${resource}/${company()}`, apiConfig());
  },

  create(payload) {
    return Repository.post(`${resource}/${company()}`, payload, apiConfig());
  },

  update(nodeCompareId, payload) {
    return Repository.put(`${resource}/${nodeCompareId}`, payload, apiConfig());
  },

  delete(nodeCompareId) {
    return Repository.delete(`${resource}/${nodeCompareId}`, apiConfig());
  },
};
